import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhoneFillSmall = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "#005AA0",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			id: "Size=Small, Property 2=Phone Fill",
			clipPath: "url(#clip0)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Subtract",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.04596 13.9459C2.05071 9.95064 0.34879 5.17497 1.99389 3.52987L3.34566 2.1781C4.12671 1.39705 5.39304 1.39705 6.17409 2.1781L8.84317 4.84718C9.40841 5.41242 9.41169 6.32682 8.85301 6.89612L7.95512 7.79401L7.9566 7.79549C7.52646 8.30844 8.08272 9.6187 9.22794 10.7639C10.3732 11.9091 11.6834 12.4654 12.1964 12.0353L12.1978 12.0367L12.2248 12.0096L12.2305 12.004L12.2362 11.9983L13.0762 11.1582C13.0794 11.155 13.0826 11.1519 13.0858 11.1487C13.6544 10.5802 14.5761 10.5802 15.1447 11.1487L17.8137 13.8178C18.5948 14.5988 18.5948 15.8651 17.8137 16.6462L16.462 17.998C14.8169 19.6431 10.0412 17.9411 6.04596 13.9459Z",
				fill: "current"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgPhoneFillSmall);
export { ForwardRef as ReactComponent };
